import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import { WebPageType } from '../../../constants/webPageType';
import { PeriodType, setPeriodList } from '../../../utils/period';
import { CircleCheckbox, SvgIcon } from '../../Molecules';
import { ActionSheetContainer } from '../Containers/ActionSheetContainer';

import styles from './SelectPeriodPopup.module.css';

type SelectPeriodPopupProps = {
  selectPeriod: PeriodType;
  createdAt: number | undefined;
  onPeriod: (
    selected: PeriodType,
    range: string,
    from: Date | undefined,
    to: Date | undefined,
  ) => void;
  onPrimary: () => void;
};

export const SelectPeriodPopup = ({
  selectPeriod,
  createdAt,
  onPeriod,
  onPrimary,
}: SelectPeriodPopupProps) => {
  const { t, i18n } = useTranslation();

  const periodList = setPeriodList(new Date(), i18n.language, createdAt);

  return (
    <ActionSheetContainer onPrimaryButtonClick={onPrimary}>
      <div className={styles.phoneNumber}>
        <div className={styles.titleRow}>
          <SvgIcon name={SVGIconType.Period} className={styles.periodIcon} />
          <p className={styles.title}>{t('Period')}</p>
        </div>
        <p className={styles.minorText}>
          {t('Performance only covers results in the period you select.')}
        </p>
        <hr className={styles.dividerPage} />

        <div className={styles.codeList}>
          {periodList.map((item, index) => (
            <div key={item.key}>
              <div
                className={styles.codeItem}
                onClick={() =>
                  onPeriod(item.key, item.range, item.from, item.to)
                }
              >
                <div className={styles.vStack}>
                  <p className={`${styles.periodName}`}>{t(item.name)}</p>
                  <p className={styles.periodRange}>{item.range}</p>
                </div>
                <CircleCheckbox
                  checked={selectPeriod === item.key}
                  webPageType={WebPageType.JOYAJOY}
                />
              </div>
              {index < periodList.length - 1 && (
                <hr className={styles.divider} />
              )}
            </div>
          ))}
        </div>
      </div>
    </ActionSheetContainer>
  );
};
